define('responsive-gameday-tracking/src/js/lib/enums/events',{
    TRACKING: "GDAppTracking",
    SCORING: "Scoring",
    SUMMARY: "Game Summary",
    FIELD_VIEW: "Field View",
    COLOR: "Social",
    ON_FIELD_LINEUPS: "On-Field Lineups",
    PITCHER: "Pitcher",
    BATTER: "Batter",
    SOCIAL: "Social",
    BINGO: "Bingo",
    MOUNDBALL: "Moundball",
    HIGHLIGHTS: "Real-Time Highlights",
    LIVE_LOOK_IN: "Live Look-in",
    USER_PREFERENCES: "User Preferences",
    ON_DECK_IN_HOLE: "On-Deck In-Hole Lineups",
    PLAYER_CARD: "Player Card",
    PITCH_VISUALIZATION: "Pitch Visualization",
    RECENT_PLAYS: "Recent Plays",
    SCOREBOARD : "Scoreboard",
    WRAPUP: "Wrap",
    PREGAME: "Preview",
    CLICK: {
        LAUNCH: 'Launch Click'
    }
});
